import { createSlice } from '@reduxjs/toolkit';

import { getActiveCities } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveCities';
import { getActiveProvinces } from 'Feature/Khodro/ShakhsSales/Thunks/getActiveProvinces';
import { CityType } from 'Shared/Core/Common/Models/CityType';
import { ProvinceType } from 'Shared/Core/Common/Models/ProvinceType';

import AddressInitialState from './AddressInitialState';

export const addressSlice = createSlice({
  name: 'Common/Address',
  initialState: AddressInitialState,
  reducers: {
    setActiveCities: (state, action) => {
      state.cities.data = action.payload;
    },
    setActiveProvinces: (state, action) => {
      state.provinces.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveCities.pending, (state) => {
        state.cities.citiesLoading = true;
      })
      .addCase(getActiveCities.fulfilled, (state, action) => {
        if (action.payload !== undefined) {
          state.cities.citiesLoading = false;
          const list: CityType[] = action.payload;
          state.cities.data = list;
        }
        return state;
      })
      .addCase(getActiveCities.rejected, (state) => {
        state.cities.citiesLoading = false;
      });

    builder
      .addCase(getActiveProvinces.pending, (state) => {
        state.provinces.provincesLoading = true;
      })
      .addCase(getActiveProvinces.fulfilled, (state, action) => {
        state.provinces.provincesLoading = false;
        if (action.payload !== undefined) {
          const list: ProvinceType[] = action.payload;
          state.provinces.data = list;
        }
        return state;
      })
      .addCase(getActiveProvinces.rejected, (state) => {
        state.provinces.provincesLoading = false;
      });
  },
});
export const { setActiveCities, setActiveProvinces } = addressSlice.actions;

export default addressSlice.reducer;
